import 'css-chunksrc/client/pages/projectPage/synthesisPage/tasks/styles.scss';export default {
  "tasks": "_tasks_1jb4k_1",
  "task": "_task_1jb4k_1",
  "name": "_name_1jb4k_22",
  "status": "_status_1jb4k_32",
  "statusName": "_statusName_1jb4k_38",
  "endDate": "_endDate_1jb4k_46",
  "late": "_late_1jb4k_54",
  "placeholder": "_placeholder_1jb4k_59"
};